import { render, staticRenderFns } from "./PriceSettingsView.vue?vue&type=template&id=414d0f96&"
import script from "./PriceSettingsView.vue?vue&type=script&lang=ts&"
export * from "./PriceSettingsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports